import { Controller } from "@hotwired/stimulus";

let ajax;

export default class extends Controller {
  connect() {
    import("@fdaciuk/ajax").then((module) => {
      ajax = module.default;
      this.init();
    });
  }

  init() {
    this.args = {
      action: "load_posts",
      offset: 0,
    };

    this.target = document.querySelector(
      this.element.getAttribute("data-target")
    );
    this.loading = false;

    let postType = this.element.getAttribute("data-post-type");
    if (postType) {
      this.args["post-type"] = postType;
    }

    let taxonomy = this.element.getAttribute("data-taxonomy");
    if (taxonomy) {
      this.args["taxonomy"] = taxonomy;
    }

    let term = this.element.getAttribute("data-term");
    if (term) {
      this.args["term"] = term;
    }

    let offset = this.element.getAttribute("data-offset");
    if (offset) {
      this.args["offset"] = parseInt(offset);
    }

    let before = this.element.getAttribute("data-before");
    if (before) {
      this.args["before"] = before;
    }

    let isHome = this.element.getAttribute("data-is-home");
    if (isHome) {
      this.args["is_home"] = true;
    }

    let scrollLoad = this.element.getAttribute("data-scroll-load");

    if (scrollLoad && scrollLoad === "true") {
      window.addEventListener(
        "scroll",
        (this.onScrollProxy = (evt) => {
          this.onScroll(evt);
        })
      );
    }

    this.element.addEventListener(
      "click",
      (this.onClickProxy = this.loadPosts.bind(this))
    );
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScrollProxy);
    this.element.removeEventListener("click", this.onClickProxy);
  }

  loadPosts() {
    if (this.loading) {
      return;
    }

    this.loading = true;
    let btnLabel = this.element.innerHTML;
    this.element.innerHTML = "Laster...";

    this.request = ajax({
      method: "get",
      url: _ajaxurl, // global
      data: this.args,
    }).then((res) => {
      this.args.offset += parseInt(res.num_posts);

      this.target.insertAdjacentHTML("beforeend", res.html);

      this.loading = false;
      this.element.innerHTML = btnLabel;

      if (!res.has_more) {
        this.element.remove();
      }
    });
  }

  onScroll(evt) {
    let windowBottomPos =
      (window.pageYOffset || document.documentElement.scrollTop) +
      window.innerHeight;

    if (windowBottomPos > document.body.scrollHeight - 600) {
      this.loadPosts();
    }
  }
}
